import Image from 'next/image'
import { List } from 'antd'

const NotificationBody = ({ notifications }) => {
  return notifications.length > 0 ? (
    <List
      size='small'
      itemLayout='horizontal'
      dataSource={notifications}
      renderItem={(item) => (
        <List.Item
          className={`${item.seen === 0 ? 'bg-green_100' : ''} flex-wrap`}
        >
          <div className='text-base xl:text-sm'>
            <span className='text-[#252733] font-bold'>{item.title}</span>
            <span className='text-gray_500'> {item.body}</span>
          </div>
          <p className='text-green text-sm text-right'>{item.created_at}</p>
        </List.Item>
      )}
    />
  ) : (
    <div className='py-68 text-center'>
      <Image
        src='https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg'
        alt='empty'
        width={87}
        height={83}
      />

      <p className='text-gray_500 text-sm font-medium mt-3'>
        Hai visualizzato tutte le notifiche
      </p>
    </div>
  )
}

export default NotificationBody
